/**
 * Return the app's current UI language ("en" or "tr"), as set by the i18n
 * system (src/lib/i18n). Used as the value of the X-Client-Language header
 * on requests to LLM/Deepgram-backed endpoints so the backend can select the
 * matching transcription model and prompt language.
 *
 * Returns undefined for English — the backend already defaults to English,
 * so omitting the header keeps existing English request behavior unchanged.
 */
import i18n from "../lib/i18n";

export function getClientLanguage(): string | undefined {
  const lng = i18n.language?.slice(0, 2);
  return lng && lng !== "en" ? lng : undefined;
}

/**
 * Build a fetch headers object including X-Client-Language when available.
 * Spread the result into your existing headers:
 *
 *   headers: { ...languageHeaders(), Authorization: `Bearer ${token}`, ... }
 */
export function languageHeaders(): Record<string, string> {
  const lng = getClientLanguage();
  return lng ? { "X-Client-Language": lng } : {};
}
